import moment from "moment";
import EmpresasService from "../../services/EmpresasServices";
import { types } from "../../types/types";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { startAlerta } from "../ui/alertas";
import { handleErrorApi } from "../../helpers/randoms";


export const limpiarSeguimiento = () => ({ type: types.limpiarSeguimientoEmpresaSuccess })
export const enviarSeguimientoEmpresa = (observacion, fechaAviso, seguimiento, cuit) =>
  async (dispatch) => {
    try {
      dispatch(startSpinner())
      let fc = moment(fechaAviso).toDate()
      let fecha = new Date(Date.UTC(fc.getFullYear(), fc.getMonth(), fc.getDate(), fc.getHours(), fc.getMinutes(), fc.getSeconds()));
      let result = await EmpresasService.actualizarSeguimiento({ cuit: cuit, fechaAviso: fecha, observacionSeguimiento: observacion, seguimiento: seguimiento })
      const body = await result.json()
      if (result.ok) {
        dispatch({
          type: types.actualizarSeguimientoEmpresasSuccess,
          payload: true
        })
        dispatch(finishSpinner())
        dispatch(startAlerta(`Seguimiento Ingresado`, 'success', 'Comando Exitoso'))
        dispatch(getSeguimientoEmpresa(cuit))
      } else {
        throw body.errores
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner())
      handleErrorApi(dispatch, error, "Error al ingresar el seguimiento.", "Ha ocurrido un error. Intente nuevamente")

    }
  }

export const getSeguimientoEmpresa = (cuit) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await EmpresasService.traerSeguimientosEmpresa(cuit);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.traerSeguimientoEmpresaSuccess,
        payload: body
      })
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(dispatch, error, "Error al traer los seguimientos.", "Ha ocurrido un error. Intente nuevamente")
  }
}


